import EulaPopup from '../../components/SystemSettings/components/EulaPopup/EulaPopup';

export interface LogoPageRoutingProps {
    setAgreeEula: () => void;
}
export default function EulaPage({ setAgreeEula }: LogoPageRoutingProps) {
    return (
        <div>
            <EulaPopup onAgree={setAgreeEula} onDisagree={() => undefined} readOnly={false} logoutOnDisagree={true} />
        </div>
    );
}
